if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const {
        InspectorControls,
        InspectorAdvancedControls,
        MediaUpload,
        InnerBlocks
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        Button
    } = window.wp.components;

    const { Fragment } = window.wp.element;

    registerBlockType('custom-gutenberg/text-content-with-bg-image', {
        // built-in attributes
        title: 'Text Content With Background Image',
        description: 'Text Content With Background Image',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            backgroundImage: {
                type: 'string',
                default: ''
            },
            anchor: {
                type: 'string',
                default: ''
            }
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                backgroundImage,
                anchor,
            } = attributes;

            const ALLOWED_BLOCKS = [
                'core/heading',
                'core/paragraph',
                'core/separator',
                'core/button',
                'custom-gutenberg/button'
            ];

            const MY_TEMPLATE = [
                [ 'core/heading', { 
                    placeholder: 'Title', 
                    className: 'text-title' 
                } ],
                [ 'core/heading', {  
                    placeholder: 'Subheading', 
                    className: 'text-subheading' 
                } ],
                [ 'core/paragraph', { 
                    placeholder: 'Description', 
                    className: 'text-content' 
                } ]
            ];

            // custom functions
            function onSelectImage (image) {
                setAttributes({backgroundImage: image.sizes.full.url});
            }
            
            return ([
                <Fragment>
                    <InspectorControls style={ { marginBottom: '40px' } }>
                        <PanelBody title={ 'Background Image Settings' }>
                            <MediaUpload 
                                onSelect={ onSelectImage }
                                type="image"
                                value={ backgroundImage } 
                                render={ ( { open } ) => (
                                    <div>
                                        { backgroundImage && 
                                            <div>
                                                <figure>
                                                    <img src={backgroundImage} />
                                                </figure>
                                                <div>
                                                    <Button onClick={() => 
                                                        setAttributes({ backgroundImage: '' })} 
                                                        className="button">
                                                            Remove
                                                    </Button>
                                                </div>
                                                <br></br>
                                            </div>
                                    
                                        }
                                    <IconButton
                                        onClick={ open }
                                        icon="upload"
                                        classNames="editor-media-placeholder__button is-button is-default is-large">
                                        Select Background Image
                                    </IconButton>
                                    </div>
                                ) } />
                        </PanelBody>
                        <PanelBody title={ 'Slide Content' }>
                        </PanelBody>
                    </InspectorControls>
                    <InspectorAdvancedControls>
                        <TextControl
                            __nextHasNoMarginBottom
                            __next40pxDefaultSize
                            label="HTML anchor"
                            value={ anchor }
                            onChange={ ( anchor ) => {
                                setAttributes( {
                                    anchor: anchor,
                                } );
                            } }
                        />
                    </InspectorAdvancedControls>
                </Fragment>
                ,
                <div id={ anchor } className="section-left section-right-of-gallery">
                    <div className="cover-image" style={{ height: 700, backgroundImage: `url(${backgroundImage})` }}>
                        <div className="container">
                            <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } template={ MY_TEMPLATE } templateLock={false} />
                        </div>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                anchor,
                backgroundImage,
            } = attributes;

            return (
                <div id={ anchor } className="text-conetent-with-bg-image">
                    <div className="lozad cover-image" data-background-image={ backgroundImage }>
                        <div className="container">
                            <div className="content-wrapper">
                                <InnerBlocks.Content />
                            </div> 
                         </div>
                    </div>
                </div>
            );
        },
    });
}